import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, ShoppingBag, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { useCart } from "@/lib/cart";
import { LaunchBar } from "./LaunchBar";
import { RemindDialog } from "./RemindDialog";

export const LINKS = [["/shop", "Shop"], ["/story", "Our story"], ["/stores", "Stores"], ["/reviews", "Reviews"], ["/nutrition", "Nutrition"], ["/faq", "FAQ"]];

const CartBtn = () => {
  const { count, setOpen } = useCart();
  return (
    <button data-testid="cart-drawer-trigger-button" onClick={() => setOpen(true)} aria-label="Open cart"
      className="relative h-11 w-11 grid place-items-center rounded-full bg-white border border-[#1B1530]/10 hover:bg-[#BDE3FA] transition-colors">
      <ShoppingBag className="h-[18px] w-[18px]" />
      {count > 0 && <span data-testid="cart-count-badge" className="absolute -top-1 -right-1 h-5 min-w-5 px-1 rounded-full bg-[#FF5A5F] text-white text-[11px] font-bold grid place-items-center">{count}</span>}
    </button>
  );
};

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="main-nav-header" className="fixed top-0 inset-x-0 z-40">
      <LaunchBar />
      <RemindDialog />
      <nav className="backdrop-blur-xl bg-[#FFF6EA]/80 border-b border-[#1B1530]/10">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
          <Link to="/" data-testid="nav-logo" className="shrink-0"><img src="/img/logo-new.webp" alt="Swole Bears home" className="h-10 sm:h-11 w-auto" /></Link>
          <div className="hidden lg:flex items-center gap-1">
            {LINKS.map(([to, label]) => (
              <NavLink key={to} to={to} data-testid={`nav-link-${to.slice(1)}`}
                className={({ isActive }) => `px-4 h-10 grid place-items-center rounded-full text-[15px] font-semibold transition-colors ${isActive ? "bg-[#1B1530] text-white" : "hover:bg-[#1B1530]/5"}`}>{label}</NavLink>
            ))}
          </div>
          <div className="flex items-center gap-2">
            <Link to="/shop" data-testid="nav-shop-cta" className="hidden sm:grid place-items-center whitespace-nowrap rounded-full bg-[#FF5A5F] text-white px-5 h-11 text-sm font-bold hover:bg-[#1B1530] transition-colors">Shop now</Link>
            <CartBtn />
            <button data-testid="mobile-menu-button" onClick={() => setOpen(!open)} aria-label="Menu" className="lg:hidden h-11 w-11 grid place-items-center rounded-full bg-[#1B1530] text-white">
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.div data-testid="mobile-menu" initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }}
            className="lg:hidden mx-3 mt-2 rounded-3xl bg-white border border-[#1B1530]/10 p-3 shadow-xl">
            {LINKS.map(([to, label]) => (
              <NavLink key={to} to={to} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${to.slice(1)}`}
                className="block px-4 py-3 font-display text-3xl rounded-2xl hover:bg-[#FFF6EA]">{label}</NavLink>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
